import React, { useEffect } from 'react'
import track, { TrackingProp } from 'react-tracking'

import BEMHelper from '@ynap/bem-helper'
import { Picture } from '@ycos/picture'

import { trackRewardsPageUpdates } from '../analytics'

const bem = new BEMHelper('StickyBottomCollapsible')

type Picture = {
    imageUrl: string
}

type StickyBottomCollapsibleProps = {
    content: {
        target: {
            teaserTitle: string
            href: string
        }
        teaserTitle: string
        subTitle?: string
        teaserText: string
        pictures?: Array<Picture>
        ynapParameter?: 'light' | 'dark'
    }
    backgroundModifier: string,
    tracking?: TrackingProp
    className?: string
    isRTL?: boolean
}

const StickyBottomCollapsible = ({ content, backgroundModifier, tracking, className, isRTL }: StickyBottomCollapsibleProps) => {
    if (!content) return null

    const { target, teaserTitle, subTitle, teaserText, pictures, ynapParameter } = content
    const teaserImageDimensions = { width: '176px', height: '136px' }
    const fontColourScheme = ynapParameter || 'dark'

    useEffect(() => {
        tracking?.trackEvent(trackRewardsPageUpdates('view', teaserTitle))
    }, [])

    return (
        <aside className={bem('container', fontColourScheme, className)} dir={isRTL ? 'rtl' : 'ltr'}>
            <details className={bem('wrapper', [backgroundModifier, fontColourScheme])}>
                <summary
                    className={bem('header', fontColourScheme)}
                    onClick={() => tracking?.trackEvent(trackRewardsPageUpdates('select', teaserTitle))}
                >
                    <p className={bem('title')}>{teaserTitle}</p>
                </summary>
                <section className={bem('expandedContent')}>
                    {pictures && (
                        <figure className={bem('imageWrapper')}>
                            <Picture
                                images={pictures}
                                imagesphere={{ quality: 80 }}
                                width={teaserImageDimensions.width}
                                lazy={true}
                                style={{
                                    objectPosition: 'top',
                                    objectFit: 'cover',
                                    height: teaserImageDimensions.height,
                                    padding: 0,
                                }}
                            />
                        </figure>
                    )}
                    <p className={bem('subTitle')}>{subTitle}</p>
                    <p className={bem('text')}>{teaserText}</p>
                    <a href={target.href} target="_blank" rel="noreferrer" className={bem('link')}>
                        {target.teaserTitle}
                    </a>
                </section>
            </details>
        </aside>
    )
}

StickyBottomCollapsible.layoutVariant = 'isc-sticky-bottom-message'

export default track({})(StickyBottomCollapsible)
